<template>
    <!-- 协作发展 共赢未来 -->
    <section class="home-company-icon">
        <div class="home-company-icon-title">
            <p>协作发展, 共赢未来</p>
            <p>Collaborative development, win-win future</p>
        </div>
        <div class="home-company-icon-content">
            <table>
                <tr>
                    <td>
                        <div class="content-img1">
                            <img src="@/assets/webImg/home/c_1.png" alt="">
                        </div>
                        <div class="content-img2">
                            <img src="@/assets/webImg/home/c_1_1.png" alt="">
                        </div>
                    </td>
                    <td>
                       <div class="content-img1">
                            <img src="@/assets/webImg/home/c_1.png" alt="">
                        </div>
                        <div class="content-img2">
                            <img src="@/assets/webImg/home/c_1_1.png" alt="">
                        </div>
                    </td>
                    <td>
                        <div class="content-img1">
                            <img src="@/assets/webImg/home/c_1.png" alt="">
                        </div>
                        <div class="content-img2">
                            <img src="@/assets/webImg/home/c_1_1.png" alt="">
                        </div>
                    </td>
                    <td>
                       <div class="content-img1">
                            <img src="@/assets/webImg/home/c_1.png" alt="">
                        </div>
                        <div class="content-img2">
                            <img src="@/assets/webImg/home/c_1_1.png" alt="">
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div class="content-img1">
                            <img src="@/assets/webImg/home/c_1.png" alt="">
                        </div>
                        <div class="content-img2">
                            <img src="@/assets/webImg/home/c_1_1.png" alt="">
                        </div>
                    </td>
                    <td>
                       <div class="content-img1">
                            <img src="@/assets/webImg/home/c_1.png" alt="">
                        </div>
                        <div class="content-img2">
                            <img src="@/assets/webImg/home/c_1_1.png" alt="">
                        </div>
                    </td>
                    <td>
                        <div class="content-img1">
                            <img src="@/assets/webImg/home/c_1.png" alt="">
                        </div>
                        <div class="content-img2">
                            <img src="@/assets/webImg/home/c_1_1.png" alt="">
                        </div>
                    </td>
                    <td>
                       <div class="content-img1">
                            <img src="@/assets/webImg/home/c_1.png" alt="">
                        </div>
                        <div class="content-img2">
                            <img src="@/assets/webImg/home/c_1_1.png" alt="">
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </section>
</template>

<script>


export default {

	data() {
		return {}
	},

	computed: {},

	created() {},

    methods: {}

}
</script>

<style lang="scss" scoped>
/** 优势特点 */
.home-company-icon {
    margin: 0 1.60rem;
    margin-top: 76px;

    .home-company-icon-title {
        text-align: center;
        p:first-child {
            font-size: 40px;
            line-height: 56px;
            color: #363636;
        }
        p:last-child {
            font-size: 33px;
            color: #B5B5B5;
            line-height: 46px;
        }
    }

    .home-company-icon-content {
        margin-top: 50px;
        table {
            // width: 1200px;
            margin: 0 auto;
            border-collapse: collapse;
            td {
                border:1px solid #E3E3E3;
                width: 396px;
                height: 340px;
                vertical-align: middle;
                text-align:center;
                cursor: pointer;
                position: relative;
                transition: all .3s linear;
                .content-img1 {
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 998;
                    width: 100%;
                    height: 100%;
                    opacity: 1;
                    transition: all .3s linear;
                }
                .content-img2 {
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 999;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                    transition: all .3s linear;
                }
                img {
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                }
            }
            td:hover {
                .content-img1 { opacity: 0; }
                .content-img2 {
                    transform: scale(1.006);
                    opacity: 1;
                }
            }
        }

    }
}

</style>
